import { Box } from "prism-react";

interface VersionListProps {
  children?: never;
  name: string;
  version: string;
}

export const VersionListItem: React.FC<VersionListProps> = ({
  name,
  version,
}) => {
  return (
    <Box
      as="li"
      css={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <Box as="span" css={{ marginRight: "$2" }}>
        {name}:
      </Box>{" "}
      <Box
        as="span"
        css={{
          textAlign: "right",
          fontFamily: "$mono",
          lineHeight: "1.3",
        }}
      >
        {version}
      </Box>
    </Box>
  );
};
